import { useContext } from 'react';
import { ClientSecretContext } from '../_components/ClientSecretContext';

export function useClientSecretContext() {
  const context = useContext(ClientSecretContext);
  if (context === undefined) {
    // Don't throw an error if context is not in parent as requested
    return { clientSecret: null, setClientSecret: () => {} };
  }
  return context;
}
